<template>
    <BaseLayout>
        <Hero
            :buttons="false"
            :cover="constants.covers.recrop"
            :background="constants.covers.recrop"
            :heading="siteContent.recropForInstagram"
            :subheading="siteContent.recropDescription"/>
        <Main>
            <div class="upload">
                <div class="toggleWrapper">
                    <Toggle class="toggleOption"
                        v-model="blurBackground"
                        :label="siteContent.blurBackground">
                        <template slot="description">
                            {{ siteContent.notSupportedInSafari }}
                        </template>
                    </Toggle>
                </div>

                <input class="fileUploadOriginal"
                    accept="image/jpeg"
                    type="file"
                    name="file"
                    id="file"
                    tabindex="-1"
                    @change="sliceUpImage"/>
                <label class="fileUpload"
                    for="file"
                    tabindex="0">
                    <div class="addFileCaption">
                        <Icon class="addFileIcon"
                            icon="add"/>
                        {{ siteContent.chooseFile }}
                    </div>
                </label>
                <p class="fileLimitCaption">
                    {{ siteContent.fileSizeLimit }}: 3 MB<br/>
                    {{ siteContent.orientation }}: {{ siteContent.landscape }}
                </p>
            </div>

            <div class="recropImages" id="images"></div>

            <Heading
                :h="2"
                size="xxl">
                {{ siteContent.whyRecrop }}
            </Heading>

            <BlurCapImage class="leading"
                v-if="!loading"
                :routerLink="'/post/' + currentPost.slug"
                :image="currentPost.cover"
                :badgeLabel="siteContent.relatedPost"
                badgeType="related">
                <LeadingPost
                    :post="currentPost"/>
            </BlurCapImage>

            <div class="donate">
                <img class="donateBg"
                    :src="constants.backgrounds.donate"/>
                <div class="content">
                    <Heading :h="3">{{ siteContent.likeThisTool }}</Heading>
                    <p>{{ siteContent.reCropDescription1 }}</p>
                    <p>{{ siteContent.reCropDescription2 }}</p>
                    <Button class="donateButton"
                        target="_blank"
                        link="https://paypal.me/lorantart">
                        {{ siteContent.donateThroughPayPal }}
                    </Button>
                </div>
            </div>
        </Main>
    </BaseLayout>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import BaseLayout from '@/components/layout/main/BaseLayout'
    import Hero from '@/components/layout/main/Hero'
    import Main from '@/components/layout/main/Main'
    import LeadingPost from '@/components/blog/main/LeadingPost'

    export default {
        name: 'Recrop',
        components: {
            BaseLayout,
            Hero,
            Main,
            LeadingPost
        },
        data() {
            return {
                blurBackground: false,
                loading: true
            }
        },
        computed: {
            ...mapState('blog',['currentPost'])
        },
        async mounted() {
            await this.fetchPostByID('recrop-for-instagram-is-here')
            this.loading = false
        },
        methods: {
            ...mapActions('blog',['fetchPostByID']),

            sliceUpImage(e) {
                if (e.target.files) {
                    let imageFile = e.target.files[0]
                    var fileSize = e.target.files[0].size / 1024 / 1024 // size in MB
                    var reader = new FileReader()
                    
                    if(fileSize > 3) {
                        this.$toasted.show(this.siteContent.under3mb)
                        return
                    } else {
                        reader.onload = (e) => {
                            var img = document.createElement("img")
                            img.onload = (event) => {
                                if(img.naturalHeight > img.naturalWidth) {
                                    this.$toasted.show(this.siteContent.alreadyPortrait)
                                    return
                                } else if(img.naturalWidth / img.naturalHeight > 8) {
                                    this.$toasted.show('Image is too wide.')
                                    return
                                } else {
                                    document.getElementById('images').innerHTML = ''
                                    var ratio = 1350 / img.naturalHeight
                                    var instances = Math.ceil(ratio * img.naturalWidth / 1080)
                                    console.log(img.naturalWidth, img.naturalHeight, instances)

                                    for(let i = 0; i < instances; i++) {
                                        var canvas = document.createElement("canvas")
                                        canvas.width = 1080
                                        canvas.height = 1350

                                        var ctx = canvas.getContext("2d")
                                        if(this.blurBackground === true) {
                                            ctx.filter = 'blur(40px)'
                                            ctx.drawImage(img, (img.naturalWidth - canvas.width) /2,
                                                                0,
                                                                canvas.width / canvas.height * img.naturalHeight,
                                                                img.naturalHeight,
                                                                (canvas.width * 1.2 - canvas.width) / 2 * -1,
                                                                (canvas.height * 1.2 - canvas.height) / 2 * -1,
                                                                canvas.width * 1.2,
                                                                canvas.height * 1.2
                                                                )
                                            ctx.filter = 'blur(0)'
                                        }
                                        ctx.drawImage(img,  canvas.width / canvas.height * img.naturalHeight * i,
                                                            0,
                                                            canvas.width / canvas.height * img.naturalHeight,
                                                            img.naturalHeight,
                                                            0,
                                                            0,
                                                            canvas.width,
                                                            canvas.height)

                                        // Show resized image in recropPreview element
                                        var dataurl = canvas.toDataURL(imageFile.type)

                                        const sliceWrapper = document.createElement("a")
                                        document.getElementById('images').appendChild(sliceWrapper)
                                        sliceWrapper.id = 'sliceWrapper' + i
                                        sliceWrapper.classList.add("recropImage")

                                        const slice = document.createElement("img")
                                        document.getElementById('sliceWrapper' + i).appendChild(slice)
                                        slice.src = dataurl
                                        slice.classList.add("recropPreview")
                                    }

                                    var canvas = document.createElement("canvas")
                                    canvas.width = 1080
                                    canvas.height = 1350

                                    var ctx = canvas.getContext("2d")
                                    
                                    if(this.blurBackground === true) {
                                        ctx.filter = 'blur(40px)'
                                        ctx.drawImage(img, (img.naturalWidth - canvas.width) /2,
                                                            0,
                                                            canvas.width / canvas.height * img.naturalHeight,
                                                            img.naturalHeight,
                                                            (canvas.width * 1.2 - canvas.width) / 2 * -1,
                                                            (canvas.height * 1.2 - canvas.height) / 2 * -1,
                                                            canvas.width * 1.2,
                                                            canvas.height * 1.2)
                                        ctx.filter = 'blur(0)'
                                        ctx.drawImage(img,  0,
                                                            0,
                                                            img.naturalWidth,
                                                            img.naturalHeight,
                                                            40,
                                                            (canvas.height - (img.naturalHeight / img.naturalWidth * 1080)) / 2,
                                                            canvas.width - 80,
                                                            img.naturalHeight / img.naturalWidth * 1000)
                                    } else {
                                        ctx.drawImage(img,  0,
                                                            0,
                                                            img.naturalWidth,
                                                            img.naturalHeight,
                                                            0,
                                                            (canvas.height - (img.naturalHeight / img.naturalWidth * 1080)) / 2,
                                                            canvas.width,
                                                            img.naturalHeight / img.naturalWidth * 1080)
                                    }
                                    
                                    var dataurl = canvas.toDataURL(imageFile.type)

                                    const sliceWrapper = document.createElement("a")
                                    document.getElementById('images').appendChild(sliceWrapper)
                                    sliceWrapper.id = 'blurredSliceWrapper'
                                    sliceWrapper.classList.add("recropImage")
                                    
                                    const slice = document.createElement("img")
                                    document.getElementById('blurredSliceWrapper').appendChild(slice)
                                    slice.src = dataurl
                                    slice.classList.add("recropPreview")
                                }
                            }
                            img.src = e.target.result
                        }
                    }
                    reader.readAsDataURL(imageFile)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

    .recrop {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 8rem;
    }

    .toggleWrapper {
        display: flex;
        padding: 1rem 1.5rem;
        background: var(--color-grey-100);
        width: 100%;
        border-radius: 1rem;
        margin-bottom: 1rem;
    }

    .fileUploadOriginal {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .fileUpload {
        display: flex;
        flex-direction: column;
    }

    .addFileCaption {
        display: flex;
        align-items: center;
    }

    .upload {
        position: relative;
        padding: 0 2rem;
        z-index: 1;
        margin-top: -2.5rem;
    }

    .fileUpload {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 3rem 0;
        border-radius: 1rem;
        transition: $transition-eio-20;
        background: var(--color-grey-100);
        cursor: pointer;
        font-family: $font-secondary;

        &:hover {
            background: var(--color-grey-200);
        }

        &:focus {
            outline: 0;
            box-shadow: var(--shadow-focus-s);
        }
    }

    .fileLimitCaption {
        margin: 0.5rem 0 2rem 0;
        font-size: 1rem;
        color: var(--color-grey-600);
    }

    .removeButton {
        margin-top: 1.5rem;
    }

    .addFileIcon {
        margin-right: 0.5rem;
        font-size: 2rem;
    }

    .donate {
        position: relative;
        margin-top: 4rem;
        background-size: cover;
        padding: 2.5rem;
        border-radius: 1.5rem;
        color: var(--color-white-important);
        overflow: hidden;
    }

    .content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;

        p {
            margin-top: 0;
        }
    }

    .donateBg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .donateButton {
        margin-top: 1.5rem;
    }

    .h2 {
        margin: 4rem 0 3rem 0;
        text-align: center;
    }

    .h3 {
        margin-top: 0;
    }

    @media all and (max-width: 560px) {
        .upload {
            padding: 0 1rem;
        }
    }
</style>

<style lang="scss">
    .recropImages {
        display: flex;
        width: 100%;
    }

    .recropImage {
        margin: 0 0.25rem 0 0;
        display: block;

        &:last-of-type {
            margin: 0;
        }
    }

    .recropPreview {
        display: flex;
        max-width: 100%;
        max-height: 40rem;
    }
</style>